import React, {Component} from 'react';
import SecondServer from '../database/SecondServer'
import {urlGetSite, urlGetAlerts} from '../database/apiUrls';
import { siteAccessCode } from '../database/apiv2SiteAccessor';
import Checkbox from '../Edit/Checkbox';
import EmailModal from './Alerts/EmailModal'
import DcapDownModal from './Alerts/DcapDownModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import {TryAgain} from '../Alert/CommonNotices'
import GridAction from './Controls/GridAction';
import { clickToNamedClass } from './RenderHelpers';
import jsonReportCfg from './reportcfg';

import './report.css'
import './alertset.css'

export default class Alerts extends Component {
  constructor(props) {
    super(props);

   this.state = {
      siteInfo: null,
      alerts: undefined,
      isLoading: true,
      alertActive: {Contact_Closure_Alert: 0, Standing_Water_Alert: 0,
        Low_Voltage_Threshold_Alert: 0, Continuous_Flow_Leak_Alert: 0,
        Power_Monitor_Alert: 0, Low_Temperature_Alert: 0, High_Temperature_Alert: 0,
      },
      arrCheckboxes: [],
      dcapDown: false,
      emailShow: false,
      supportedLists: [],
      errorMsg: undefined,
    };
    this.reportId = 'alertset';

    this.onCheck = this.onCheck.bind(this)
    this.addCallback = this.addCallback.bind(this)
    this.newMail = this.newMail.bind(this)
    this.toggleClick = this.toggleClick.bind(this)
    this.removeEmail = this.removeEmail.bind(this)

    this.apiNames = jsonReportCfg.data[this.reportId].apiFilter.slice(2, 10)
    this.apiEmailLists = ["all_alert_targets", "low_batt_alert_targets", "contact_closure_alert_targets", 
      "power_monitor_alert_targets", "low_temperature_targets", "high_temperature_targets",
      "standing_water_leak_detect_alert_targets", "continuous_flow_leak_detect_alert_targets",
      "dcap_down_alert_targets"]
    this.ss = new SecondServer(this.props)
    this._mounted = undefined
  }

async componentDidMount() {
  this._mounted = true
  const site = this.props.getActiveSite();
  const siteinfo = await this.ss.apiData (urlGetSite(siteAccessCode(site)))
  const alertInfo = await this.ss.apiData (urlGetAlerts(siteAccessCode(site)))
  const alertState = this.alertInfoToState(alertInfo?.data?.data?.alerts)
  //console.log(siteinfo, alertInfo)
  if (this._mounted) {
    this.setState( {alerts: alertInfo?.data?.data?.alerts, siteInfo: siteinfo?.data?.data,
      alertActive: alertState, errorMsg: this.ss.getErrorMsg(), 
      arrCheckboxes: this.initCheckboxen (alertInfo?.data?.data?.alerts, siteinfo?.data?.data),
      supportedLists: this.filterApiLists (alertInfo?.data?.data?.alerts), isLoading: false})
  }
}
componentWillUnmount() {
  this._mounted = false
  this.ss.cancel("notifications")
}
alertInfoToState (apiData) {
  let newState = this.state.alertActive
  if (Array.isArray(apiData)) {
    this.apiNames.forEach (name => {
    const wanted = apiData.find(i => i.alert_kind === name)
    const enabled = wanted?.sensors[0]?.enableCnt
    const newish = enabled ? Number(enabled) : 0
    newState[name] = newish
  })}
  return newState
}
distinctEmails (alerts, siteInfo) {
  const lists = alerts?.map (item => item.email_list_name) ?? []
  const emails = lists.map (list => siteInfo[list])
  const validEmails = emails.filter (item => item !== undefined)
  const flatEmails = validEmails.flat(1)
  const result = flatEmails.filter((item, index) => index === flatEmails.findIndex(email => email === item))
  return result
}
initCheckboxen (alerts, siteInfo) {
  const emails = this.distinctEmails(alerts, siteInfo)
  const rows = emails.length
  const checks = this.availableChecks(alerts)
  const newArr = Array(rows*checks.length)
  newArr.fill(false)
  return this.setChecksFromApi (alerts, siteInfo, emails, newArr)
}
setChecksFromApi(alerts, siteInfo, emails, arrBox) {
  const kinds = this.availableKinds(alerts)
  const row = this.availableChecks(alerts).length
  const lists = this.filterApiLists(alerts)
  emails.forEach ((email, outerIndex) => {
    const subscribed = lists.map(list => siteInfo[list]?.includes(email) ? list : undefined)
    const names = subscribed.map (sub => alerts.find(item => item.email_list_name === sub)?.alert_kind)
    const justNames = names.filter (name => name !== undefined)
    const indices = justNames.map(name => kinds.indexOf(name))
    indices.forEach(index => arrBox[row*outerIndex + index+1] = true)
    // console.log (subscribed, justNames, indices)
  })
  return arrBox
}

apiLogCheck (state, index) {
  const perRow = this.availableChecks(this.state.alerts)
  const offset = index % perRow.length
  const rowIndex = Math.floor(index / perRow.length)
  const emails = this.distinctEmails (this.state.alerts, this.state.siteInfo)
  const list = this.state.supportedLists[offset]
  let apiData = this.state.siteInfo[list] ?? []
  if (state)
    (!apiData.includes(emails[rowIndex])) && apiData.push(emails[rowIndex])
  else
    apiData = apiData.filter (i => i !== emails[rowIndex])
  const apiObj = {[list]: apiData}
  //console.log (apiObj)
  this.ss.apiSaveData (urlGetSite(siteAccessCode(this.props.getActiveSite())), apiObj)
  this.setState ( {errorMsg: this.ss.getErrorMsg() } );
}
isDcapDown(index) {
  const perRow = this.availableChecks(this.state.alerts)
  const offset = index % perRow.length
  return (offset === 0 || offset === perRow.length -1)
}
onCheck (state, index) {
  const dcapDialog = (state && this.isDcapDown(index))
  let temp = this.state.arrCheckboxes;
  temp[index] = state;
  this.setState({arrCheckboxes : temp, dcapDown: dcapDialog})
  this.apiLogCheck (state, index)
}

checkCell(props) {
  return <td className="csv-td" key={"check"+props.key}>
    <Checkbox parentData={this.onCheck} {...props}/></td>
}
checkRow (len, rowIndex) {
  const base = rowIndex * len
  const row = this.state?.arrCheckboxes?.slice (base, base+len) ?? []
  const allSelected = row[0] > 0
  return (
    row.map ((type, index) => this.checkCell({selected: allSelected || type, key: index, index: base+index, disabled:(index>0 ? allSelected:false)}))
  )
}
newMail(modalState) {
  //console.log (modalState)
  this.componentDidMount()
}
toggleClick(name) {
  let current = this.state.alerts.filter(kind => kind.alert_kind === name)
  const change = current[0].sensors[0].enableCnt > 0 ? 'Disabled' : 'Enabled'
  current[0].sensors[0].state = change
  const body = {data: {'alerts': current}}
  const site = this.props.getActiveSite();
  this.ss.apiInsertData (urlGetAlerts(siteAccessCode(site)), body)
  let newActive = this.state.alertActive
  newActive[name] = newActive[name] > 0 ? 0 : 1
  this.setState ({alertActive: newActive})
}
supportedKind(name, alerts) {
  const inPlay = alerts ?? this.state?.alerts
  if (inPlay) {
    let wanted = inPlay.find(i => i.alert_kind === name)
    if (wanted && name === "Dcap_Down_Alert")
      wanted.sensors = ["placeholder"]
    return wanted?.sensors.length
  }
  return 0
}
filterApiLists (alerts) {
  const result = this.apiEmailLists.filter((list, index) =>
    index === 0 || this.supportedKind(this.apiNames[index-1], alerts)
  )
  return result
}
filterTableTitle() {
  const cfg = jsonReportCfg.data.alertset
  const result = cfg.displayName.filter((name, index) => 
      cfg.apiFilter[index] === undefined || this.supportedKind(cfg.apiFilter[index]))
  return result;
}
filterTitleId() {
  const cfg = jsonReportCfg.data.alertset
  const result = cfg.displayOrder.filter((name, index) => 
      cfg.apiFilter[index] === undefined || this.supportedKind(cfg.apiFilter[index]))
  return result
}
availableKinds (alerts) {
  const kinds = this.apiNames.map(name => this.supportedKind (name, alerts) ? name : undefined)
  return kinds.filter (kind => kind!==undefined)
}
availableChecks (alerts) {
  let alertType = this.apiNames.map (name => this.supportedKind (name, alerts))
  alertType = alertType.filter (i => i > 0) 
  alertType.unshift(1)
  return alertType;    
}
async removeEmail(evt){
  const btn= clickToNamedClass(evt, "actButton")
  const index = btn.getAttribute('index')
  const emails = this.distinctEmails(this.state.alerts, this.state.siteInfo);
  if (emails && index < emails.length) {
    emails.splice (index, 1)
    //console.log (emails)
    const url = urlGetSite(siteAccessCode(this.props.getActiveSite()))
    await this.ss.apiSaveData(url, {"all_alert_targets" : emails})
    this.componentDidMount()
  }
}
addCallback () {
  const ns = this.state.emailShow ? false : true
  this.setState ({emailShow: ns})
}
dcapModal = () => {
  this.setState({dcapDown: !this.state.dcapDown})
} 
renderEditButtons () {
  return (
    <div className="alertplace">
    <span className="csvbutton-dot" onClick={this.addCallback}>
      <FontAwesomeIcon  className="fadd-button" icon={faPlus} color="#498679"/>
    </span>
    <span className="btnlabel"> Add Email</span>
    </div>
  )
}
renderTable() {
  if (this.state.isLoading) {
    return <div className="loader" />
  }
  if (this.state.errorMsg) {
    return (<TryAgain errMsg={this.state.errorMsg} />)
  }
  const alertType = this.availableChecks(this.state?.alerts);
  const recip = this.distinctEmails(this.state.alerts, this.state.siteInfo);
  const colName = this.filterTableTitle()
  const colId = this.filterTitleId()
  return (
    <div className="table-container">
      <table className="csv-table-short" id='dispTable'>
        <thead><tr>
          {colName.map((i, index) =>
            <th className={index === 0 ? 'csv-th' : 'csv-th alert-narrow-col'}
              id={colId[index]} key={colId[index]}>{i}</th>)}
        </tr></thead><tbody>
      {recip?.map((email, index) =>
        <tr className="csv-tr" key={index}>
          <td className="csv-td email-table" key="email">{email}</td>
          {this.checkRow(alertType.length, index)}
          <td><GridAction id='action' index={index} onRemove={this.removeEmail}/></td>
        </tr>
      )}
      </tbody>
      </table>
    </div>
  )
}
render() {
  return (
      <div className="container-fluid smoke-bg">
        <div className="content-title alert-emails">Alert Recipients
        {this.renderEditButtons()}
        </div>
        <DcapDownModal show={this.state.dcapDown} hide={this.dcapModal} {...this.props}
          siteInfo={this.state.siteInfo} onChange={this.newMail} />
        <EmailModal show={this.state.emailShow} hide={this.addCallback} {...this.props} 
            siteInfo={this.state.siteInfo} onChange={this.newMail} />
        {this.renderTable ()}
      </div>
    )
  }
}
